import { render, staticRenderFns } from "./EmbedField.vue?vue&type=template&id=9b8ab1ce&"
import script from "./EmbedField.vue?vue&type=script&lang=js&"
export * from "./EmbedField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports